
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import Link from '@ecl/eu-react-component-link';
import demoContentDefault from '@ecl/eu-specs-link/demo/data--default';
import demoContentStandalone from '@ecl/eu-specs-link/demo/data--standalone';
import demoContentCTA from '@ecl/eu-specs-link/demo/data--cta';
import demoContentCTAIcon from '@ecl/eu-specs-link/demo/data--cta-icon';
import demoContentIcon from '@ecl/eu-specs-link/demo/data--icon';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Default link`}</h2>
    <Playground system="eu" selectedKind="components-navigation-link" selectedStory="default" mdxType="Playground">
  <p className="ecl-u-type-paragraph">
    The European Commission is the executive of <Link {...demoContentDefault} mdxType="Link" />{' '}
    and promotes its general interest.
  </p>
    </Playground>
    <h2>{`Standalone link`}</h2>
    <Playground system="eu" selectedKind="components-navigation-link" selectedStory="standalone" mdxType="Playground">
  <Link {...demoContentStandalone} mdxType="Link" />
    </Playground>
    <h2>{`Link with icon`}</h2>
    <Playground system="eu" selectedKind="components-navigation-link" selectedStory="default" mdxType="Playground">
  <p className="ecl-u-type-paragraph">
    The European Commission is the executive of <Link {...demoContentIcon} mdxType="Link" />{' '}
    and promotes its general interest.
  </p>
    </Playground>
    <h2>{`Call-to-action link`}</h2>
    <Playground system="eu" selectedKind="components-navigation-link" selectedStory="cta" mdxType="Playground">
  <Link {...demoContentCTA} mdxType="Link" />
    </Playground>
    <Playground system="eu" selectedKind="components-navigation-link" selectedStory="cta" mdxType="Playground">
  <Link {...demoContentCTAIcon} mdxType="Link" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;